import { EditorCardProvider } from '@atlaskit/editor-card-provider';
import { prefetchNodeDataProvidersData } from '@atlaskit/node-data-provider';

import { SSRMeasures } from '@confluence/action-measures';

const MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';

export async function preloadEditorNodeDataProvidersData(docJsonString: string | undefined) {
	if (!docJsonString) {
		return;
	}

	await SSRMeasures.run(MEASURE_SEGMENT, async () => {
		const doc = JSON.parse(docJsonString);

		const providers = [
			{
				provider: new EditorCardProvider(undefined, undefined, 'CONFLUENCE'),
				// The same value as `DEFAULT_ORS_TIMEOUT` in next/packages/content-smartlinks/src/preloadContentSmartLinksConstants.ts
				timeout: 500,
				// Reasonable value for smart card prefetching.
				maxNodesToPrefetch: 10,
			},
		];

		providers.forEach(({ provider }) => {
			SSRMeasures.markMeasureStart(measureProviderSegment(provider.name));
		});

		const editorNodeDataProvidersData = await prefetchNodeDataProvidersData({
			doc,
			providers,
			timeout: 500,
			// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
			maxNodesToVisit: 10_000,
		});

		Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration }]) => {
			SSRMeasures.setMeasureDuration(measureProviderSegment(providerName), duration);
		});

		window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(
			Object.entries(editorNodeDataProvidersData).map(([providerName, { data }]) => [
				providerName,
				data,
			]),
		);
	});
}

function measureProviderSegment(providerName: string) {
	return `${MEASURE_SEGMENT}/${providerName}`;
}
